import React, { Fragment } from "react";
import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import { useParams } from "react-router-dom";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarExport,
  gridClasses,
} from "@mui/x-data-grid";
import { Fab, Card } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import api from "../../../components/services/api";
import SearchData from "../components/SearchData";
import { display } from "@mui/system";
import PropTypes from "prop-types";
import FilledInput from "@mui/material/FilledInput";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import InputAdornment from "@mui/material/InputAdornment";
import FormHelperText from "@mui/material/FormHelperText";
import FormControl from "@mui/material/FormControl";
import SearchIcon from "@mui/icons-material/Search";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { CardActionArea, CardActions } from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Tooltip from "@mui/material/Tooltip";
import Paper from "@mui/material/Paper";
import { makeStyles } from "@mui/styles";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import CircularProgress from "@mui/material/CircularProgress";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
function Item(props) {
  const { sx, ...other } = props;
  return (
    <Box
      sx={{
        bgcolor: "primary.main",
        color: "white",
        p: 1,
        m: 1,
        borderRadius: 1,
        textAlign: "center",
        fontSize: "1rem",
        fontWeight: "700",
        ...sx,
      }}
      {...other}
    />
  );
}

Item.propTypes = {
  sx: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object])),
    PropTypes.func,
    PropTypes.object,
  ]),
};

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    marginTop: theme.spacing(3),
    overflowX: "auto",
  },
  table: {
    minWidth: 700,
  },
}));

const getListStyle = (isDraggingOver) => ({
  background: isDraggingOver ? "lightblue" : "lightgrey",
  padding: 4,
  width: 120,
});

const getItemStyle = (isDragging, draggableStyle) => ({
  // some basic styles to make the items look a bit nicer
  userSelect: "none",
  // change background colour if dragging
  background: isDragging ? "lightgreen" : "white",
  width: isDragging ? "50px" : "auto",
  border: "1px solid rgba(0, 0, 0, 0.05)",
  padding: 4,
  borderRadius: 5,
  marginTop: 2,
  // styles we need to apply on draggables
  ...draggableStyle,
});

function escapeRegExp(value) {
  return value.toString().replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&");
}

export default function CyShip() {
  const classes = useStyles();
  const [dataShip, setDataShip] = useState([]);
  const [ContainerList, setContainerList] = useState([]);
  const [detailTiresRows, setDetailTiresRows] = useState([]);
  const [BtnViewAll, setBtnViewall] = useState(5);
  const [CallData, setCallData] = useState(false);
  const EmpId = localStorage.getItem("EmpId");
  //search
  const [searchText, SetSearchText] = useState("");
  let { id } = useParams();
  const [sample, setSample] = useState([
    { name: "ROW 1", detail: [[], [], [], []] },
    { name: "ROW 2", detail: [[], [], [], []] },
    { name: "ROW 3", detail: [[], [], [], []] },
  ]);
  const [container_data, setContainer_data] = useState([
    { id: "1", content: " Container 000231", size: "20" },
    { id: "2", content: " Container 000223", size: "20" },
    { id: "3", content: " Container 000234 Size 40", size: "40" },
    { id: "4", content: " Container 000235 S40", size: "40" },
    { id: "5", content: " Container 000236", size: "20" },
  ]);

  // a little function to help us with reordering the result
  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);

    return result;
  };

  const move = (source, destination, droppableSource, droppableDestination) => {
    const sourceClone = Array.from(source);
    const destClone = Array.from(destination);

    let _name = droppableDestination.droppableId.split("_");

    const newItems = [...detailTiresRows];

    const size = sourceClone[droppableSource.index]?.ContainerTypeId;

    if (size === "40") {
      if (
        newItems[_name[1]].detail[_name[2]][_name[3]] ||
        newItems[_name[1]].detail[_name[2]][(parseInt(_name[3]) + 1).toString()]
      ) {
        const MySwal = withReactContent(Swal);
        MySwal.fire({
          icon: "info",
          didOpen: () => {
            MySwal.clickConfirm();
          },
        }).then(() => {
          return MySwal.fire(
            "ไม่สามารถดำเนินการได้!",
            "กรุณาเลือกพื้นที่อื่น เนื่องจากมีข้อมูลอยู่แล้ว !",
            "info"
          );
        });
        // console.log("ไม่ว่าง");
      } else {
        const [removed] = sourceClone.splice(droppableSource.index, 1);
        const _newObj = {
          ...removed,
          bay: _name[3],
          row: _name[1],
          tires: _name[2],
        };
        // console.log(size);
        // newItems[_name[1]].detail[_name[2]][_name[3]] = removed;

        if (size === "40") {
          const _newObj40 = {
            ...removed,
            bay: (parseInt(_name[3]) + 1).toString(),
            row: _name[1],
            tires: _name[2],
          };
          newItems[_name[1]].detail[_name[2]][
            (parseInt(_name[3]) + 1).toString()
          ] = _newObj40;

          const data_move40 = [
            {
              typeCy: "CYSHIP",
              containerTypeId: _newObj40?.ContainerTypeId,
              containerNo: _newObj40?.ContainerNo,
              booking: _newObj40?.Booking,
              bay: _name[3],
              row: _newObj40?.row,
              tires: _newObj40?.tires,
              status: 1,
              createId: EmpId,
              voyNo: id,
              groupId: _newObj40?.GroupShipmentId,
              branchId: "",
              warehouseId: "",
              idStockmovement: _newObj40?.idStockmovement,
            },
            {
              typeCy: "CYSHIP",
              containerTypeId: _newObj40?.ContainerTypeId,
              containerNo: _newObj40?.ContainerNo,
              booking: _newObj40?.Booking,
              bay: (parseInt(_name[3]) + 1).toString(),
              row: _newObj40?.row,
              tires: _newObj40?.tires,
              status: 1,
              createId: EmpId,
              voyNo: id,
              groupId: _newObj40?.GroupShipmentId,
              branchId: "",
              warehouseId: "",
              idStockmovement: _newObj40?.idStockmovement,
            },
          ];
          insertContainer(data_move40);
        } else {
          // newItems[_name[1]].detail[_name[2]][_name[2]] = removed; ////////เจาะผิด

          const data_move = [
            {
              typeCy: "CYSHIP",
              containerTypeId: _newObj?.ContainerTypeId,
              containerNo: _newObj?.ContainerNo,
              booking: _newObj?.Booking,
              bay: _newObj?.bay,
              row: _newObj?.row,
              tires: _newObj?.tires,
              status: 1,
              createId: EmpId,
              voyNo: id,
              groupId: _newObj?.GroupShipmentId,
              branchId: "",
              warehouseId: "",
              idStockmovement: _newObj?.idStockmovement,
            },
          ];

          // console.log(data_move);

          insertContainer(data_move);
        }
        newItems[_name[1]].detail[_name[2]][_name[3]] = _newObj; ////////เจาะผิด
        setDetailTiresRows(newItems);
      }
    } else {
      if (newItems[_name[1]].detail[_name[2]][_name[3]]) {
        const MySwal = withReactContent(Swal);
        MySwal.fire({
          icon: "info",
          didOpen: () => {
            MySwal.clickConfirm();
          },
        }).then(() => {
          return MySwal.fire(
            "ไม่สามารถดำเนินการได้!",
            "กรุณาเลือกพื้นที่อื่น เนื่องจากมีข้อมูลอยู่แล้ว !",
            "info"
          );
        });
        // console.log("ไม่ว่าง");
      } else {
        const [removed] = sourceClone.splice(droppableSource.index, 1);
        const _newObj = {
          ...removed,
          bay: _name[3],
          row: _name[1],
          tires: _name[2],
        };

        // newItems[_name[1]].detail[_name[2]][_name[3]] = removed;
        if (size === "40") {
          const _newObj40 = {
            ...removed,
            bay: (parseInt(_name[3]) + 1).toString(),
            row: _name[1],
            tires: _name[2],
          };
          newItems[_name[1]].detail[_name[2]][
            (parseInt(_name[3]) + 1).toString()
          ] = _newObj40;

          const data_move40 = [
            {
              typeCy: "CYSHIP",
              containerTypeId: _newObj40?.ContainerTypeId,
              containerNo: _newObj40?.ContainerNo,
              booking: _newObj40?.Booking,
              bay: _name[3],
              row: _newObj40?.row,
              tires: _newObj40?.tires,
              status: 1,
              createId: EmpId,
              voyNo: id,
              groupId: _newObj40?.GroupShipmentId,
              branchId: "",
              warehouseId: "",
              idStockmovement: _newObj40?.idStockmovement,
            },
            {
              typeCy: "CYSHIP",
              containerTypeId: _newObj40?.ContainerTypeId,
              containerNo: _newObj40?.ContainerNo,
              booking: _newObj40?.Booking,
              bay: (parseInt(_name[3]) + 1).toString(),
              row: _newObj40?.row,
              tires: _newObj40?.tires,
              status: 1,
              createId: EmpId,
              voyNo: id,
              groupId: _newObj40?.GroupShipmentId,
              branchId: "",
              warehouseId: "",
              idStockmovement: _newObj40?.idStockmovement,
            },
          ];
          // console.log(data_move);
          insertContainer(data_move40);
        } else {
          // newItems[_name[1]].detail[_name[2]][_name[2]] = removed; ////////เจาะผิด

          const data_move = [
            {
              typeCy: "CYSHIP",
              containerTypeId: _newObj?.ContainerTypeId,
              containerNo: _newObj?.ContainerNo,
              booking: _newObj?.Booking,
              bay: _newObj?.bay,
              row: _newObj?.row,
              tires: _newObj?.tires,
              status: 1,
              createId: EmpId,
              voyNo: id,
              groupId: _newObj?.GroupShipmentId,
              branchId: "",
              warehouseId: "",
              idStockmovement: _newObj?.idStockmovement,
            },
          ];

          // console.log(data_move);

          insertContainer(data_move);
        }
        newItems[_name[1]].detail[_name[2]][_name[3]] = _newObj; ////////เจาะผิด

        setDetailTiresRows(newItems);
      }
    }
    // console.log(newItems);

    const result = {};
    result[droppableSource.droppableId] = sourceClone;
    result[droppableDestination.droppableId] = destClone;

    return result;

    // console.log(
    //   filter_name);
  };

  const id2List = {
    droppable: ContainerList,
    droppable2: detailTiresRows,
  };

  const getList = (id) => id2List[id];
  const onDragEnd = (result) => {
    const { source, destination } = result;

    // dropped outside the list
    if (!result.destination) {
      return;
    }
    const start = result.source.droppableId;
    const finish = result.destination.droppableId;

    if (start == finish) {
      const items = reorder(
        ContainerList,
        result.source.index,
        result.destination.index
      );
      // setContainer_data(items);
      setContainerList(items);
    } else {
      //  console.log(getList(source.droppableId));
      const result = move(
        getList(source.droppableId),
        detailTiresRows,
        source,
        destination
      );
      // console.log(result);
      // setContainer_data(result.droppable);
      setContainerList(result.droppable);
    }
  };

  const getDetailShip = async () => {
    const params = {
      voy: id,
    };
    try {
      const data = await api.post("api/tally/max/cyship", params);

      data.data.map(async (x) => {
        setDataShip(x);

        await ReformatData(x?.CyRows, x?.CyTires);
      });
    } catch (e) {
      console.log(e);
    }
  };

  const getContainerList = async () => {
    const params = {
      voy: id,
    };
    try {
      const data = await api.post("api/tally/container/list", params);
      // setContainerList()
      setContainerList(data.data);
    } catch (e) {
      console.log(e);
    }
  };

  const insertContainer = async (data_move) => {
    console.log(data_move);
    try {
      const data = await api.post("api/tally/create", data_move);

      // console.log(data.data);
    } catch (e) {
      console.log(e);
    }
  };

  setTimeout(async () => {
    // await drawDataTable();
    // await getContainerList();
    console.log('first 1')
  }, 10000);

  const drawDataTable = async (data_move) => {
    const params = {
      voy: id,
    };
    const newItems = [...detailTiresRows];
    // console.log(newItems);
    try {
      const data = await api.post("api/tally/container/detail", params);

      detailTiresRows.map((x, indexX) => {
        x.detail.map((xs, indexXs) => {
          data?.data.map((el) => {
            if (
              parseInt(el?.CyRow) === indexX &&
              parseInt(el?.Tires) === indexXs
            ) {
              newItems[indexX].detail[indexXs][el?.Bay] = el;
            }
          });
        });
      });
    } catch (e) {
      console.log(e);
    }

    setDetailTiresRows(newItems);
  };

  const DelContainerTable = async (xr) => {
    const params = {
      containerNo: xr,
      cyType: "CYSHIP",
    };
    try {
      const data = await api.post("api/tally/container/delete", params);
    } catch (e) {
      console.log(e);
    }
  };

  useEffect(async () => {
    // await getDetailShip();
    // await getContainerList();
    console.log('first 2')
    // await drawDataTable();
  }, []);

  useEffect(async () => {
    if (detailTiresRows?.length > 0) {
      // await drawDataTable();
      console.log('first 3')
    }
  }, [CallData || ContainerList]);

  const ReformatData = (row, tires) => {
    let newArray = [];

    Array.from(Array(parseInt(row ? row : 0)), (item, num) => {
      let newDataS = { names: "", detail: [] };
      newDataS["names"] = "ROW " + parseInt(num + 1);

      Array.from(Array(parseInt(tires ? tires : 0)), (item, i) => {
        for (let s = 0; s <= i; s++) {
          newDataS["detail"][s] = [];
        }
      });
      newArray = [...newArray, newDataS];
    });

    setDetailTiresRows(newArray);

    setCallData(true);

    // console.log(newArray);
  };

  useEffect(() => {
    if (searchText.length === 0) {
      // setContainerList()
      // console.log(data);
      console.log('first 4')
      // getContainerList();
    } else {
      const searchRegex = new RegExp(escapeRegExp(searchText), "i");
      const result = ContainerList.filter((row) => {
        return Object.keys(row).some((field) => {
          return searchRegex.test(row[field]);
        });
      });
      console.log(result);
      setContainerList(result);

      // console.log(result);
      // console.log(data);
      // console.log(searchText.length);
    }
  }, [searchText]);

  return (
    <>
      <Paper elevation={1} style={{ overflow: "auto", marginTop: 5 }}>
        <DragDropContext
          onDragEnd={(result) =>
            onDragEnd(result, ContainerList, setContainerList)
          }
        >
          <div style={{ display: "flex" }}>
            <Card
              variant="outlined"
              style={{ padding: "15px", margin: "10px", width: "50%" }}
            >
              <Grid container alignItems="center" spacing={1}>
                <Grid item xs>
                  <Typography
                    className="textcolordarkblue"
                    variant="h5"
                    component="h1"
                  >
                    Find Container
                  </Typography>
                </Grid>
              </Grid>

              <div style={{ marginTop: 10 }}>
                <FormControl sx={{ m: 1, width: "25ch" }} variant="outlined">
                  <OutlinedInput
                    onChange={(e) => SetSearchText(e.target.value)}
                    id="outlined-adornment-weight"
                    value={searchText}
                    startAdornment={
                      <InputAdornment position="end">
                        <SearchIcon />
                      </InputAdornment>
                    }
                    placeholder="Search Container Id"
                    aria-describedby="outlined-weight-helper-text"
                    inputProps={{
                      "aria-label": "weight",
                    }}
                  />
                </FormControl>
              </div>
              <div style={{ display: "flex" }}>
                <Grid
                  justify="space-between" // Add it here :)
                  container
                  spacing={24}
                >
                  <Grid item>
                    <Typography type="title">Result</Typography>
                  </Grid>

                  <Grid item>
                    <div>
                      <Typography
                        style={{ cursor: "pointer" }}
                        onClick={() => {
                          if (BtnViewAll === 5) {
                            setBtnViewall(ContainerList?.length);
                          } else {
                            setBtnViewall(5);
                          }
                        }}
                        type="title"
                      >
                        View All {">"}
                      </Typography>
                    </div>
                  </Grid>
                </Grid>
              </div>
              <div>
                <Grid item>
                  <div style={{ marginTop: 10 }}>
                    <Typography color="gray">
                      {" "}
                      Drag and Drop Container Id to Plan
                    </Typography>
                  </div>
                </Grid>
              </div>
              {/* {console.log(detailTiresRows)} */}
              <div>
                <Droppable droppableId="droppable">
                  {(provided, _snapshot) => {
                    return (
                      <div
                        {...provided.droppableProps}
                        ref={provided.innerRef}
                        style={{
                          width: 250,
                        }}
                      >
                        {ContainerList.slice(0, BtnViewAll).map(
                          (item, index) => {
                            // console.log(item.id)
                            return (
                              <Draggable
                                key={item.idStockmovement}
                                draggableId={item.idStockmovement}
                                index={index}
                              >
                                {(provided, _snapshot) => {
                                  return (
                                    <div
                                      ref={provided.innerRef}
                                      {...provided.draggableProps}
                                      {...provided.dragHandleProps}
                                      style={getItemStyle(
                                        _snapshot.isDragging,
                                        provided.draggableProps.style
                                      )}
                                    >
                                      {item.ContainerNo}
                                    </div>
                                  );
                                }}
                              </Draggable>
                            );
                          }
                        )}
                        {provided.placeholder}
                      </div>
                    );
                  }}
                </Droppable>
              </div>
            </Card>

            <Card
              variant="outlined"
              style={{ padding: "15px", margin: "10px", width: "100%" }}
            >
              <div>
                <Grid container alignItems="center" spacing={1}>
                  <Grid item xs>
                    <div style={{ display: "flex" }}>
                      {" "}
                      <Typography
                        className="textcolordarkblue"
                        variant="h5"
                        component="h1"
                      >
                        SHIP CY
                      </Typography>
                      {/* <Box
                        component="span"
                        sx={{
                          ml: 5,
                          border: "1px solid grey",
                          borderRadius: 5,
                        }}
                      >
                        <div style={{ display: "flex" }}>
                          <Box
                            sx={{
                              display: "flex",
                              flexDirection: "row",

                              m: 1,
                              bgcolor: "background.paper",
                            }}
                          >
                            <Item>Zone 1</Item>
                            <Item>Zone 2</Item>
                            <Item>Zone 3</Item>
                          </Box>
                          <Button
                            variant="outlined"
                            style={{
                              color: "#84BD5A",
                              borderColor: "#84BD5A",
                              border: "1px solid #84BD5A",
                              margin: 20,
                            }}
                            size="small"
                          >
                            + Add Zone
                          </Button>
                        </div>
                      </Box> */}
                    </div>
                  </Grid>
                </Grid>
              </div>
              <div style={{ display: "flex", marginTop: 10 }}>
                <Grid
                  justify="space-between" // Add it here :)
                  container
                  spacing={24}
                >
                  {/* <Grid item>
                    <Typography
                      className="textcolordarkblue"
                      variant="h5"
                      component="h1"
                    >
                      ZONE 1
                    </Typography>
                  </Grid> */}

                  <Grid item>
                    <div>
                      <Typography
                        className="textcolordarkblue"
                        variant="h6"
                        component="h1"
                      >
                        VOY : {id}
                      </Typography>
                    </div>
                  </Grid>
                </Grid>
              </div>
              <div>
                <Box
                  sx={{
                    width: "100%",
                    marginTop: "10px",
                  }}
                >
                  <Paper className={classes.root} style={{ overflow: "auto" }}>
                    <TableContainer sx={{ maxHeight: 600 }}>
                      <Table className={classes.table} stickyHeader>
                        <TableHead>
                          <TableRow>
                            <TableCell></TableCell>

                            {Array.from(
                              Array(
                                parseInt(dataShip?.CyBay ? dataShip?.CyBay : 0)
                              ),
                              (e, i) => {
                                return (
                                  <TableCell align="right">
                                    Bay {i + 1}
                                  </TableCell>
                                );
                              }
                            )}
                          </TableRow>
                        </TableHead>

                        <TableBody>
                          {/* {console.log(detailTiresRows)} */}
                          {detailTiresRows.map((item, el) => (
                            <>
                              <Fragment>
                                <TableRow>
                                  <TableCell
                                    style={{
                                      position: "sticky",
                                      left: 0,
                                      background: "white",
                                      zIndex: 800,
                                    }}
                                    rowSpan={item.detail.length + 1}
                                  >
                                    {item.names}
                                  </TableCell>
                                </TableRow>
                              </Fragment>
                              {item.detail.map((detail, index) => (
                                <TableRow>
                                  {Array.from(
                                    Array(
                                      parseInt(
                                        dataShip?.CyBay ? dataShip?.CyBay : 0
                                      )
                                    ),
                                    (e, indexBay) => {
                                      return (
                                        <TableCell>
                                          <div style={{ display: "flex" }}>
                                            <Droppable
                                              droppableId={
                                                item.names +
                                                "_" +
                                                el +
                                                "_" +
                                                index +
                                                "_" +
                                                indexBay
                                              }
                                            >
                                              {(provided, snapshot) => (
                                                <div
                                                  ref={provided.innerRef}
                                                  style={getListStyle(
                                                    snapshot.isDraggingOver
                                                  )}
                                                >
                                                  {/* {console.log(detail)} */}
                                                  {
                                                    // detail[indexBay]?.content
                                                    detail[indexBay]
                                                      ?.ContainerNo
                                                  }{" "}
                                                  {provided.placeholder}
                                                </div>
                                              )}
                                            </Droppable>
                                            {/* {console.log(detail[indexBay])} */}

                                            {detail[indexBay]?.ContainerNo ? (
                                              <Button
                                                variant="contained"
                                                style={{ marginLeft: "5px" }}
                                                onClick={() => {
                                                  const old_value =
                                                    detail[indexBay];
                                                  const newItems = [
                                                    ...detailTiresRows,
                                                  ];
                                                  newItems[el].detail[index][
                                                    indexBay
                                                  ] = "";
                                                  // console.log(old_value.size);
                                                  const size =
                                                    old_value?.ContainerTypeId;
                                                  if (size === "40") {
                                                    newItems[el].detail[index][
                                                      indexBay + 1
                                                    ] = "";
                                                  }
                                                  setDetailTiresRows(newItems);
                                                  // setContainer_data([
                                                  //   ...container_data,
                                                  //   old_value,
                                                  // ]);
                                                  setContainerList([
                                                    ...ContainerList,
                                                    old_value,
                                                  ]);
                                                  console.log(old_value);
                                                  DelContainerTable(
                                                    old_value?.ContainerNo
                                                  );
                                                }}
                                              >
                                                ลบ
                                              </Button>
                                            ) : null}
                                          </div>
                                        </TableCell>
                                      );
                                    }
                                  )}
                                </TableRow>
                              ))}
                            </>
                          ))}

                          {/* {sample.map((item,el) => (
             
        
      
          ))} */}
                        </TableBody>
                      </Table>
                    </TableContainer>
                    {/* <Button
                      variant="outlined"
                      onClick={() => {
                        // console.log(container_data);
                        console.log(detailTiresRows);
                      }}
                    >
                      {" "}
                      Save
                    </Button> */}
                  </Paper>
                </Box>
              </div>
            </Card>
          </div>
        </DragDropContext>
      </Paper>
    </>
  );
}
